
































import {Vue, Component, Prop} from 'vue-property-decorator';
// @ts-ignore
import Swiper from 'swiper';

@Component({
    name: 'ProjectSlider',
})
export default class ProjectSlider extends Vue {
    @Prop({required: true}) public sliderImages!: string[];

    public mounted(): void {
        this.swiperManagement();
    }

    public get createSlider(): boolean {
        return this.sliderImages.length > 1;
    }

    private swiperManagement() {
        const swiper = new Swiper('.swiper-container', {
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            pagination: {
                el: '.swiper-pagination',
                dynamicBullets: true,
            },
        });
    }
}
